import { gql } from '@apollo/client';

const GET_DASH_DATA = gql`
  query GetDashboardData($storeId: ID!, $offset: Int, $limit: Int) {
    getDashboardData(storeId: $storeId, offset: $offset, limit: $limit) {
      ... on GetDashboardDataSuccess {
        code
        data {
          devolutions {
            total
            exchanged
            refunded
            credits
            methods {
              index
              devolutions
            }
            reasons {
              id
              name
              devolutions
            }
          }
          configs {
            storeInfo
            cliqueRetireIntegration
            correiosIntegration
            devolutionPageConfig
            configsAndRules
            customEmails
          }
        }
      }
      ... on Error {
        code
        message
      }
    }
  }
`;

export default {
  GET_DASH_DATA,
};
